import { Icon } from './publish/Icons';

export class Widget {
  id: number;
  siteId: number;
  versionDate: Date;
  fullText: string;
  summaryText: string;
  introductionText: string;
  customerDataRetention: number;
  position: string;
  layoutName: string;
  summaryButton: string;
  summaryButton2: string;
  fullButton: string;
  isPublished: boolean;
  elementColors: WidgetColors;
  icon: Icon;
  showOnPageLoad: boolean;
  displayOptions: number;
}

export enum PrivacyPolicyType {
  // TODO: Move
  NotSet,
  Draft,
  Published,
}

export class WidgetColors {
  panelBackground: string;
  panelText: string;
  buttonBackground: string;
  buttonText: string;
  closeButton: Element;
}

export class Element {
  backgroundColor: string;
  textColor: string;
}

export enum DisplayOptions {
  ShowtoAll,
  LinkedFromWidgets,
  HTMLLink,
}
